import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'floor_positions': '[FloorPositionInputType]',
};

export default gql(`
	mutation floor_positions( ${ HelperGraphql.createFields( fields ) } ) {
	    floor_positions( ${ HelperGraphql.createVariables( fields ) } ) {
	       guid
	       position
	    }
	}
`);

